import { render } from "./inquiries.vue?vue&type=template&id=e62c7bc2"
import script from "./inquiries.vue?vue&type=script&lang=js"
export * from "./inquiries.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\zhuxu\\source\\repos\\innosource\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__